// Marketplace mock dataset.

export const marketplaceKpis = {
  monthlyRevenue: { value: "£128,420", trend: "+18.2%", sub: "Feb 2026 to date" },
  activePartners: { value: 142, trend: "+9", sub: "Across 9 categories" },
  referralsLive: { value: 87, trend: "+24", sub: "Live transactions supported" },
  conversion: { value: "76.4%", trend: "+3.1pp", sub: "Avg across partners" },
  topPerformer: { value: "Hill Dickinson", trend: "96 score", sub: "Conversion leader" },
  aiSuggestions: { value: 5, trend: "Today", sub: "New partner matches" },
};

export const categories = [
  { id: "all",         name: "All services",        count: 142, icon: "Sparkles" },
  { id: "solicitors",  name: "Solicitors",          count: 28,  icon: "Scale" },
  { id: "brokers",     name: "Mortgage Brokers",    count: 19,  icon: "Banknote" },
  { id: "surveyors",   name: "Surveyors",            count: 22,  icon: "Ruler" },
  { id: "epc",         name: "EPC Providers",        count: 12,  icon: "Leaf" },
  { id: "removals",    name: "Removal Companies",   count: 14,  icon: "Truck" },
  { id: "contractors", name: "Contractors",         count: 18,  icon: "Hammer" },
  { id: "insurance",   name: "Insurance Providers",  count: 11,  icon: "ShieldCheck" },
  { id: "compliance",  name: "Compliance",          count: 9,   icon: "BadgeCheck" },
  { id: "leasehold",   name: "Leasehold Specialists",count: 9,   icon: "ScrollText" },
];

export const partners = [
  {
    id: "p-1", category: "solicitors", logoColor: "rose",  logoText: "HD",
    name: "Hill Dickinson LLP",      tagline: "National full-service · 220+ partners",
    rating: 4.9, reviews: 312, responseHrs: 3.2, avgDays: 32, successPct: 94, conversionPct: 88,
    activeTx: 14, revenueShare: "8%", priceTier: "premium",
    specialisms: ["Leasehold", "Buy-to-let", "Cross-border"],
    badge: "Top performer",
    flag: "Faster than 92% of solicitors on the network",
  },
  {
    id: "p-2", category: "brokers", logoColor: "amber", logoText: "TF",
    name: "Trinity Financial",       tagline: "Whole-of-market mortgage brokerage",
    rating: 4.8, reviews: 268, responseHrs: 1.8, avgDays: 18, successPct: 91, conversionPct: 84,
    activeTx: 22, revenueShare: "Tiered", priceTier: "standard",
    specialisms: ["Self-employed", "BTL", "Bridging"],
    badge: "AI recommended",
    flag: "Highest conversion this month",
  },
  {
    id: "p-3", category: "surveyors", logoColor: "blue", logoText: "RC",
    name: "Robinson & Co Surveyors", tagline: "RICS chartered, 28 years",
    rating: 4.7, reviews: 189, responseHrs: 4.6, avgDays: 7, successPct: 96, conversionPct: 79,
    activeTx: 9, revenueShare: "12%", priceTier: "standard",
    specialisms: ["Listed buildings", "Period property", "Lender panels"],
    badge: null,
    flag: "Best for Victorian terraces",
  },
  {
    id: "p-4", category: "solicitors", logoColor: "violet", logoText: "BR",
    name: "Brabners LLP",            tagline: "North-West specialist · property focused",
    rating: 4.1, reviews: 124, responseHrs: 9.4, avgDays: 51, successPct: 78, conversionPct: 62,
    activeTx: 8, revenueShare: "6%", priceTier: "standard",
    specialisms: ["Leasehold", "New build"],
    badge: "Watch",
    flag: "Response 2.4× slower than network mean",
  },
  {
    id: "p-5", category: "removals", logoColor: "emerald", logoText: "BX",
    name: "Bexley Removals & Storage", tagline: "Premium white-glove movers",
    rating: 4.9, reviews: 421, responseHrs: 2.1, avgDays: 1, successPct: 99, conversionPct: 81,
    activeTx: 16, revenueShare: "10%", priceTier: "premium",
    specialisms: ["Listed access", "Long-distance", "Storage"],
    badge: null,
    flag: "Highest client satisfaction in network",
  },
  {
    id: "p-6", category: "epc", logoColor: "emerald", logoText: "EC",
    name: "EcoCert Surveys",          tagline: "Same-week EPC across UK",
    rating: 4.6, reviews: 95, responseHrs: 1.2, avgDays: 4, successPct: 98, conversionPct: 88,
    activeTx: 11, revenueShare: "Flat",  priceTier: "low",
    specialisms: ["Same-week", "Commercial", "MEES advice"],
    badge: null,
    flag: "Average 3.8 days from instruction to certificate",
  },
  {
    id: "p-7", category: "insurance", logoColor: "blue", logoText: "PB",
    name: "PolicyBase Insurance",     tagline: "Buildings + contents specialists",
    rating: 4.5, reviews: 78, responseHrs: 0.6, avgDays: 0.5, successPct: 100, conversionPct: 92,
    activeTx: 18, revenueShare: "Comm",  priceTier: "low",
    specialisms: ["Buildings", "Unoccupied", "Listed"],
    badge: null,
    flag: "Issued before exchange in 99% of cases",
  },
  {
    id: "p-8", category: "leasehold", logoColor: "violet", logoText: "LH",
    name: "Leasehold Advisory Co.",   tagline: "Lease extensions & enfranchisement",
    rating: 4.8, reviews: 64, responseHrs: 5.0, avgDays: 22, successPct: 92, conversionPct: 71,
    activeTx: 5, revenueShare: "10%", priceTier: "premium",
    specialisms: ["Extensions", "Disputes", "Section 42"],
    badge: "Specialist",
    flag: "Strong for short lease purchases",
  },
];

export const referrals = [
  { id: "r-1", client: "M. Bellingham",  property: "21 Wellington Crescent", partner: "Hill Dickinson LLP", category: "Solicitor", date: "11 Feb", status: "active",     revenue: "£480",  progress: 58 },
  { id: "r-2", client: "M. Bellingham",  property: "21 Wellington Crescent", partner: "Trinity Financial",  category: "Broker",    date: "13 Feb", status: "active",     revenue: "£640",  progress: 72 },
  { id: "r-3", client: "A. Khoury",       property: "Apt 14, The Heron",      partner: "Robinson & Co",       category: "Surveyor",  date: "18 Feb", status: "completed",  revenue: "£320",  progress: 100 },
  { id: "r-4", client: "T. Beckett",      property: "32 Falkner Square",      partner: "Bexley Removals",     category: "Removals",  date: "Today",  status: "pending",    revenue: "—",     progress: 12 },
  { id: "r-5", client: "C. Aldridge",    property: "8 Cornwall Gardens",     partner: "PolicyBase",          category: "Insurance", date: "Yesterday", status: "completed", revenue: "£160", progress: 100 },
  { id: "r-6", client: "R. Johansson",   property: "Apt 6 Royal Albert Wharf", partner: "Brabners LLP",      category: "Solicitor", date: "07 Feb", status: "stalled",     revenue: "—",   progress: 24 },
];

export const aiPartnerInsights = [
  { id: "ai-1", tone: "low",  title: "Best solicitor for fast leasehold exchanges",        detail: "Hill Dickinson LLP averages 32 days vs network mean 41 — recommend for The Heron and Falkner Square." , action: "Auto-refer" },
  { id: "ai-2", tone: "low",  title: "Highest conversion mortgage broker this month",      detail: "Trinity Financial converted 84% of referrals (network mean 67%). 22 live transactions supported.",  action: "Pin to top" },
  { id: "ai-3", tone: "low",  title: "Recommended surveyor based on property type",        detail: "Wellington Crescent (Victorian terrace) — Robinson & Co has 96% success rate on similar stock.",   action: "Refer now" },
  { id: "ai-4", tone: "high", title: "Response times below target for current solicitor",  detail: "Brabners LLP avg response 9.4h vs target ≤4h. Affecting 8 deals · consider partner swap.",        action: "Compare alternatives" },
  { id: "ai-5", tone: "low",  title: "Strong completion performance detected",             detail: "PolicyBase Insurance issued buildings cover before exchange in 99% of cases over last 90 days.",  action: "Add to default stack" },
];

export const insightsPanel = {
  revenueRing: 78, // monthly target progress
  revenueTarget: "£165K",
  leaderboard: [
    { name: "Hill Dickinson LLP",    revenue: "£18,420", deals: 14, change: "+12%" },
    { name: "Trinity Financial",      revenue: "£14,180", deals: 22, change: "+9%" },
    { name: "Bexley Removals",        revenue: "£9,840",  deals: 16, change: "+15%" },
    { name: "Robinson & Co Surveyors",revenue: "£7,260",  deals: 9,  change: "+4%" },
    { name: "PolicyBase Insurance",   revenue: "£5,120",  deals: 18, change: "+22%" },
  ],
  fastestSolicitors: [
    { name: "Hill Dickinson LLP", days: 32 },
    { name: "Linklaters",          days: 35 },
    { name: "Slater & Gordon",     days: 38 },
  ],
  bestBrokers: [
    { name: "Trinity Financial", conv: 84 },
    { name: "Mortgage Hub",      conv: 78 },
    { name: "Coreco Brokers",    conv: 72 },
  ],
  growthOpps: [
    { title: "Activate EPC bundle on listing flow",         impact: "+£3.2K/mo" },
    { title: "Add insurance pre-exchange nudge",             impact: "+£2.1K/mo" },
    { title: "Promote Bexley Removals on completion call",  impact: "+£1.8K/mo" },
  ],
  responseRanks: [
    { name: "PolicyBase Insurance", hrs: 0.6 },
    { name: "EcoCert Surveys",      hrs: 1.2 },
    { name: "Trinity Financial",    hrs: 1.8 },
  ],
};
